import OverItem from '@/modules/contract/components/dialogOver/components/overItem/overItem';
import { Markup, Over } from '@/modules/contract/entities/interfaces/over';
import { normalizeOver } from '@/modules/contract/services/normalizeOver';
import React, { useMemo } from 'react';
import { Row } from 'vkit/lib/context';

export interface OverContentProps {
  markups: Markup[];
}

const OverContent: React.FC<OverContentProps> = ({ markups }) => {
  const listOvers = useMemo(() => {
    return normalizeOver(markups);
  }, [markups]);

  return (
    <Row style={{ gap: 16 }}>
      {listOvers.map((over: Over, index) => (
        <OverItem key={over.id} isFirstItem={index === 0} over={over} />
      ))}
    </Row>
  );
};

export default OverContent;
